




















import Vue, { PropType } from 'vue';
import EmployeePortrait from '@/components/EmployeePortrait.vue';
import Employee from '@/models/employee';

export default Vue.extend({
  name: 'EmployeesPanel',
  components: {
    EmployeePortrait,
  },
  props: {
    title: {
      type: String,
      default: () => 'Ansatte',
    },
    employees: {
      type: Array as PropType<Array<Employee>>,
      required: true,
    },
    titleSize: String,
    titlePosition: String,
  },
});
